/**
 * Gesamtsuche für Beteiligte (Kundenfeedback 18.10.2026, XII): eigene
 * Kontakte, in KARS registrierte Organisationen und das
 * Versicherungsverzeichnis in einer Anfrage. Favoriten mit Standardrolle.
 */
import type { Contact } from "./contactModel";
import type { Insurance } from "./contactsApi";
import { getRequestGeneric, putRequestGeneric } from "./backendApiGeneric";

/** Mindestlänge des Suchbegriffs (Backend prüft ebenfalls). */
export const CONTACT_SEARCH_MIN_LENGTH = 2;

export interface ContactSearchResponse {
  query: string;
  own: Contact[];
  /** Organisationsbaum wie GET /protected/organizations/search */
  registered: unknown[];
  insurances: Insurance[];
}

export function searchContacts(query: string): Promise<ContactSearchResponse> {
  return getRequestGeneric(`/protected/contacts/search?q=${encodeURIComponent(query.trim())}`);
}

/** Favorit setzen/entfernen; favoriteRole = Standardrolle (Fall-Rolle) oder null. */
export function setContactFavorite(id: number, isFavorite: boolean, favoriteRole: string | null): Promise<Contact> {
  return putRequestGeneric(`/protected/contacts/${id}/favorite`, { isFavorite, favoriteRole }, true);
}
